/**
 * The todo status and priority vocabularies, in a module that imports nothing.
 *
 * They live beside `todo.schema.ts` rather than inside it for the same bundle
 * reason `offer-vocabulary.ts` gives: `router.tsx` imports every route's
 * `validateSearch` schema EAGERLY, because a search schema has to exist at
 * route-definition time, before the route component is ever loaded. The todos
 * search schemas filter on status and priority, and reaching for the Zod enums
 * dragged the whole todo row, input, link and reorder schema set into the
 * initial chunk.
 *
 * These tuples are the single source of truth: `todo.schema.ts` builds
 * `todoStatusSchema` and `todoPrioritySchema` from them, so the URL parser and
 * the wire parser cannot drift.
 */

export const TODO_STATUSES = ["open", "in_progress", "completed"] as const;
export type TodoStatusName = (typeof TODO_STATUSES)[number];

export const TODO_PRIORITIES = ["low", "medium", "high", "critical"] as const;
export type TodoPriorityName = (typeof TODO_PRIORITIES)[number];
